import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

// The module's tabs, each declaring its route + label key once. Adding a tab is
// a single entry here.
const MODULE_TABS = [
  { value: 'invoices', to: '/invoices', labelKey: 'moduleTabs.invoices' },
  {
    value: 'credit-notes',
    to: '/credit-notes',
    labelKey: 'moduleTabs.creditNotes',
  },
] as const

type ModuleTab = (typeof MODULE_TABS)[number]['value']

// Tab bar shared by the Invoices list and the Credit notes list, so credit
// notes are reachable as a tab inside the Invoice management module (WBS 2.6.9).
// Each tab is its own route; switching tab navigates, and the active tab
// reflects the current route.
export function InvoiceModuleTabs({ active }: { active: ModuleTab }) {
  const navigate = useNavigate()
  const { t } = useTranslation('invoices')
  return (
    <Tabs
      value={active}
      onValueChange={v => {
        const tab = MODULE_TABS.find(tab => tab.value === v)
        if (tab) navigate(tab.to)
      }}
    >
      <TabsList className='w-full items-end overflow-x-visible border-b-2'>
        {MODULE_TABS.map(tab => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            className='-mb-0.5 px-3 pb-2 pt-1 text-base font-normal leading-[1.4]'
          >
            {t(tab.labelKey)}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}

export default InvoiceModuleTabs
